<div *ngIf="user">
    <nb-radio-group
        class="d-flex justify-content-center"
        *ngIf="selection"
        [(ngModel)]="selected"
        (ngModelChange)="select.emit(user)"
    >
        <nb-radio [value]="user">Selecionar</nb-radio>
    </nb-radio-group>
    <nb-list>
        <nb-list-item class="d-flex justify-content-between">
            <p class="paragraph-2 text-hint mb-0">Nome</p>
            <p class="paragraph-2 mb-0">{{ user.nome }}</p>
        </nb-list-item>
        <nb-list-item class="d-flex justify-content-between">
            <p class="paragraph-2 text-hint mb-0">Email</p>
            <p class="paragraph-2 mb-0">{{ user.email }}</p>
        </nb-list-item>
        <nb-list-item class="d-flex justify-content-between">
            <p class="paragraph-2 text-hint mb-0">Celular</p>
            <p class="paragraph-2 mb-0">{{ user.fone_cel_ddd_numero }}</p>
        </nb-list-item>

        <nb-list-item class="d-flex justify-content-between">
            <p class="paragraph-2 text-hint mb-0">Data de Nascimento</p>
            <p class="paragraph-2 mb-0">{{ user.dt_nascimento }}</p>
        </nb-list-item>
        <nb-list-item class="d-flex justify-content-between">
            <p class="paragraph-2 text-hint mb-0">Documento</p>
            <p class="paragraph-2 mb-0">{{ user.document }}</p>
        </nb-list-item>
    </nb-list>
</div>
